
// Constants used by lead services
export const MOCK_DEALER_ID = '5f5f5f5f-5f5f-5f5f-5f5f-5f5f5f5f5f5f';
